import { authorizedProdAPIClient } from './BaseRepository';

export const sendEmail = (data) => {
  return authorizedProdAPIClient.post('/_connect', data);
};
